import FeaturedImage from '@/components/FeaturedImage'
import Link from 'next/link'
import styles from './FeaturedCaseStudies.module.scss'

export default function FeaturedCaseStudies(props) {
  const featuredCaseStudies = props.fields.featuredCaseStudies

  if (!featuredCaseStudies || featuredCaseStudies.length === 0) {
    return null
  }

  const getPreferredImage = (casestudy) => {
    return casestudy?.caseStudyFields?.cardImage?.node || casestudy?.caseStudyFields?.heroImage?.node || null
  }

  return (
    <>
      <div className={styles.caseStudiesComponent} data-cy="featured-case-studies">
        <div className={styles.caseStudiesComponentWrapper}>
          <span data-aos="fade-up" className={styles.eyebrowText}>
            OUR WORK IN ACTION
          </span>
          <h2 data-aos="fade-up" className={styles.casestudiesHeading}>
            Featured Case Studies
          </h2>

          <div data-aos="fade-up" className={`container ${styles.caseSutdiesContainer}`}>
            <div className={styles.caseStudies}>
              {featuredCaseStudies.nodes.map((casestudy, index) => (
                <Link href={casestudy?.uri ?? '#'} passHref key={index} data-cy="featured-case-study-link">
                  <div className={styles.card}>
                    <FeaturedImage
                      className={casestudy?.caseStudyFields?.cardImage?.node ? styles.cardImage : styles.heroImage}
                      image={getPreferredImage(casestudy)}
                      width={540}
                      height={230}
                      sizes="(max-width: 767px) 100vw, 50vw"
                      data-cy="featured-case-study-image"
                    />
                    <div className={styles.headingInfo}>
                      <span className={styles.title} data-cy="featured-case-study-title">
                        {casestudy.title}
                      </span>
                      <div
                        className={styles.headingTitle}
                        dangerouslySetInnerHTML={{
                          __html: casestudy.caseStudyFields.title
                        }}
                        data-cy="featured-case-study-heading"
                      ></div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
